import * as React from 'react';
import { observer } from 'mobx-react';
import { CheckBoxCardNoBorder } from '../select/CheckBoxCardNoBorder';
import './checkBoxInput.module.scss';

type CheckBoxInputProps = {
    checked: boolean;
    label: string;
    onCheck: (checked: boolean) => any;
    error?: string;
    className?: string;
};

export const CheckBoxInput = observer(({ checked, onCheck, error, label, className }: CheckBoxInputProps) => {
    return (
        <div styleName="check-box-input-wrapper">
            <CheckBoxCardNoBorder label={label} checked={checked} onCheck={onCheck} className={className} />
            {error && <div styleName="error">{error}</div>}
        </div>
    );
});
